// Global variables for pagination
let currentPage = 1;
let currentItemsPerPage = 24; // Default to show 24 items per page

// Global variables for filters
let isFilterLoading = false;

// Mobile filter functionality
function toggleFilters() {
    const sidebar = document.querySelector('.filters-sidebar');
    const overlay = document.querySelector('.filter-overlay');
    
    sidebar.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeFilters() {
    const sidebar = document.querySelector('.filters-sidebar');
    const overlay = document.querySelector('.filter-overlay');
    
    sidebar.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = 'auto';
}

// Handle pagination for client-side (Items per page functionality)
function handlePagination() {
    const allProductCards = document.querySelectorAll('.product-card');
    const itemsPerPage = currentItemsPerPage || 24;
    
    // If "All" is selected, show all products
    if (currentItemsPerPage === 1000) {
        allProductCards.forEach(card => {
            card.style.display = 'flex';
        });
        
        // Hide pagination when showing all
        const paginationContainer = document.querySelector('.pagination-container');
        if (paginationContainer) {
            paginationContainer.style.display = 'none';
        }
        return;
    }
    
    // Show pagination when not showing all
    const paginationContainer = document.querySelector('.pagination-container');
    if (paginationContainer) {
        paginationContainer.style.display = 'flex';
    }
    
    // Calculate pagination
    const totalProducts = allProductCards.length;
    const totalPages = Math.ceil(totalProducts / itemsPerPage);
    
    // Ensure current page is within bounds
    if (currentPage > totalPages) {
        currentPage = totalPages || 1;
    }
    
    // Hide all products first
    allProductCards.forEach(card => {
        card.style.display = 'none';
    });
    
    // Show products for current page
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    
    let visibleCount = 0;
    allProductCards.forEach((card, index) => {
        if (index >= startIndex && index < endIndex) {
            card.style.display = 'flex';
            visibleCount++;
        }
    });
    
    // Update pagination UI
    updatePaginationUI(totalPages);
}

// Update pagination UI
function updatePaginationUI(totalPages) {
    const paginationContainer = document.querySelector('.pagination-container');
    if (!paginationContainer) return;
    
    // Clear existing pagination
    const pagination = paginationContainer.querySelector('.pagination');
    if (pagination) {
        pagination.innerHTML = '';
    }
    
    // Add previous button
    const prevBtn = document.createElement('button');
    prevBtn.className = `pagination-btn prev-btn ${currentPage === 1 ? 'disabled' : ''}`;
    prevBtn.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    prevBtn.addEventListener('click', () => {
        if (currentPage > 1) {
            currentPage--;
            handlePagination();
        }
    });
    pagination.appendChild(prevBtn);
    
    // Add page numbers
    for (let i = 1; i <= totalPages; i++) {
        const pageBtn = document.createElement('button');
        pageBtn.className = `pagination-btn ${i === currentPage ? 'active' : ''}`;
        pageBtn.textContent = i;
        pageBtn.addEventListener('click', () => {
            currentPage = i;
            handlePagination();
        });
        pagination.appendChild(pageBtn);
    }
    
    // Add next button
    const nextBtn = document.createElement('button');
    nextBtn.className = `pagination-btn next-btn ${currentPage === totalPages ? 'disabled' : ''}`;
    nextBtn.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    nextBtn.addEventListener('click', () => {
        if (currentPage < totalPages) {
            currentPage++;
            handlePagination();
        }
    });
    pagination.appendChild(nextBtn);
}

// Close filters when pressing Escape key
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        closeFilters();
    }
});

// ===== AJAX FILTER FUNCTIONALITY =====

// Setup filter click handlers
function setupFilterClickHandlers() {
    // Remove existing event listeners to prevent duplicates
    const existingOptions = document.querySelectorAll('.filter-option');
    existingOptions.forEach(option => {
        option.replaceWith(option.cloneNode(true));
    });
    
    // Find all filter options
    const filterOptions = document.querySelectorAll('.filter-option');
    
    filterOptions.forEach(function(option) {
        // Make the entire option clickable
        option.style.cursor = 'pointer';
        option.addEventListener('click', function(e) {
            if (isFilterLoading) return; // Prevent multiple clicks during loading
            
            // Find the checkbox
            const checkbox = option.querySelector('input[type="checkbox"]');
            const customCheckbox = option.querySelector('.filter-checkbox');
            
            if (checkbox) {
                checkbox.checked = !checkbox.checked;
                
                // Update visual state
                if (customCheckbox) {
                    if (checkbox.checked) {
                        customCheckbox.classList.add('checked');
                    } else {
                        customCheckbox.classList.remove('checked');
                    }
                }
                
                // Apply the filter with AJAX
                applyFiltersWithAJAX();
            }
        });
    });
}

// Apply filters with AJAX
function applyFiltersWithAJAX() {
    if (isFilterLoading) return;
    
    const form = document.getElementById('FacetFiltersForm');
    if (!form) return;
    
    isFilterLoading = true;
    
    // Show loading state
    showFilterLoadingState();
    
    // Get current URL
    const currentUrl = new URL(window.location.href);
    
    // Clear existing filter parameters
    const filterParams = Array.from(currentUrl.searchParams.keys()).filter(key => key.startsWith('filter.'));
    filterParams.forEach(param => currentUrl.searchParams.delete(param));
    
    // Add all checked checkboxes as parameters
    const checkedBoxes = form.querySelectorAll('input[type="checkbox"]:checked');
    checkedBoxes.forEach(box => {
        currentUrl.searchParams.set(box.name, box.value);
    });
    
    // Add section_id parameter for AJAX
    currentUrl.searchParams.set('section_id', 'category-items');
    
    // Fetch the new content
    fetch(currentUrl.toString())
        .then(response => response.text())
        .then(html => {
            // Parse the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Find the new products grid and filters
            const newProductGrid = doc.querySelector('.category-products-grid');
            const newFilters = doc.querySelector('.filters-sidebar');
            
            // Update the products grid
            if (newProductGrid) {
                const currentGrid = document.querySelector('.category-products-grid');
                if (currentGrid) {
                    currentGrid.innerHTML = newProductGrid.innerHTML;
                }
            }
            
            // Update the filters sidebar
            if (newFilters) {
                const currentFilters = document.querySelector('.filters-sidebar');
                if (currentFilters) {
                    currentFilters.innerHTML = newFilters.innerHTML;
                    // Re-setup click handlers for the new filter elements
                    setTimeout(function() {
                        setupFilterClickHandlers();
                    }, 100);
                }
            }
            
            // Update URL without reload
            window.history.pushState({}, '', currentUrl.pathname + currentUrl.search);
            
            // Hide loading state
            hideFilterLoadingState();
            
            // Re-initialize pagination after filter update
            handlePagination();
        })
        .catch(error => {
            console.error('Error fetching filtered results:', error);
            
            // Hide loading state on error
            hideFilterLoadingState();
            
            // Fallback to page reload
            window.location.href = currentUrl.toString();
        })
        .finally(() => {
            isFilterLoading = false;
        });
}

// Show loading state for filters
function showFilterLoadingState() {
    const productGrid = document.querySelector('.category-products-grid');
    const loadingOverlay = document.querySelector('.loading-overlay');
    
    if (productGrid) {
        productGrid.style.opacity = '0.6';
        productGrid.style.pointerEvents = 'none';
    }
    
    if (loadingOverlay) {
        loadingOverlay.style.display = 'block';
    }
    
    // Add loading class to body
    document.body.classList.add('is-loading');
}

// Hide loading state for filters
function hideFilterLoadingState() {
    const productGrid = document.querySelector('.category-products-grid');
    const loadingOverlay = document.querySelector('.loading-overlay');
    
    if (productGrid) {
        productGrid.style.opacity = '1';
        productGrid.style.pointerEvents = 'auto';
    }
    
    if (loadingOverlay) {
        loadingOverlay.style.display = 'none';
    }
    
    // Remove loading class from body
    document.body.classList.remove('is-loading');
}

// Clear all filters
function clearAllFilters() {
    if (isFilterLoading) return;
    
    isFilterLoading = true;
    
    // Show loading state
    showFilterLoadingState();
    
    // Get current URL and remove all filter parameters
    const currentUrl = new URL(window.location.href);
    
    // Clear all filter parameters
    const filterParams = Array.from(currentUrl.searchParams.keys()).filter(key => key.startsWith('filter.'));
    filterParams.forEach(param => currentUrl.searchParams.delete(param));
    
    // Add section_id parameter for AJAX
    currentUrl.searchParams.set('section_id', 'category-items');
    
    // Fetch the new content
    fetch(currentUrl.toString())
        .then(response => response.text())
        .then(html => {
            // Parse the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Find the new products grid and filters
            const newProductGrid = doc.querySelector('.category-products-grid');
            const newFilters = doc.querySelector('.filters-sidebar');
            
            // Update the products grid
            if (newProductGrid) {
                const currentGrid = document.querySelector('.category-products-grid');
                if (currentGrid) {
                    currentGrid.innerHTML = newProductGrid.innerHTML;
                }
            }
            
            // Update the filters sidebar
            if (newFilters) {
                const currentFilters = document.querySelector('.filters-sidebar');
                if (currentFilters) {
                    currentFilters.innerHTML = newFilters.innerHTML;
                    // Re-setup click handlers for the new filter elements
                    setTimeout(function() {
                        setupFilterClickHandlers();
                    }, 100);
                }
            }
            
            // Update URL without reload
            window.history.pushState({}, '', currentUrl.pathname + currentUrl.search);
            
            // Hide loading state
            hideFilterLoadingState();
            
            // Re-initialize pagination after filter update
            handlePagination();
        })
        .catch(error => {
            console.error('Error clearing filters:', error);
            
            // Hide loading state on error
            hideFilterLoadingState();
            
            // Fallback to page reload
            window.location.href = currentUrl.toString();
        })
        .finally(() => {
            isFilterLoading = false;
        });
}

// Remove individual filter
function removeFilter(paramName, value) {
    if (isFilterLoading) return;
    
    isFilterLoading = true;
    
    // Show loading state
    showFilterLoadingState();
    
    // Get current URL
    const currentUrl = new URL(window.location.href);
    
    // Remove the specific filter parameter
    currentUrl.searchParams.delete(paramName);
    
    // Add section_id parameter for AJAX
    currentUrl.searchParams.set('section_id', 'category-items');
    
    // Fetch the new content
    fetch(currentUrl.toString())
        .then(response => response.text())
        .then(html => {
            // Parse the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Find the new products grid and filters
            const newProductGrid = doc.querySelector('.category-products-grid');
            const newFilters = doc.querySelector('.filters-sidebar');
            
            // Update the products grid
            if (newProductGrid) {
                const currentGrid = document.querySelector('.category-products-grid');
                if (currentGrid) {
                    currentGrid.innerHTML = newProductGrid.innerHTML;
                }
            }
            
            // Update the filters sidebar
            if (newFilters) {
                const currentFilters = document.querySelector('.filters-sidebar');
                if (currentFilters) {
                    currentFilters.innerHTML = newFilters.innerHTML;
                    // Re-setup click handlers for the new filter elements
                    setTimeout(function() {
                        setupFilterClickHandlers();
                    }, 100);
                }
            }
            
            // Update URL without reload
            window.history.pushState({}, '', currentUrl.pathname + currentUrl.search);
            
            // Hide loading state
            hideFilterLoadingState();
            
            // Re-initialize pagination after filter update
            handlePagination();
        })
        .catch(error => {
            console.error('Error removing filter:', error);
            
            // Hide loading state on error
            hideFilterLoadingState();
            
            // Fallback to page reload
            window.location.href = currentUrl.toString();
        })
        .finally(() => {
            isFilterLoading = false;
        });
}

// Initialize page functionality
document.addEventListener('DOMContentLoaded', function() {
    // Items per page functionality
    const itemsSelect = document.getElementById('items-select');
    if (itemsSelect) {
        itemsSelect.addEventListener('change', function() {
            const selectedValue = this.value;
            if (selectedValue === 'all') {
                currentItemsPerPage = 1000; // Show all items
            } else {
                currentItemsPerPage = parseInt(selectedValue);
            }
            // Reset to first page when changing items per page
            currentPage = 1;
            
            // Apply pagination (works with Search & Discovery filtered results)
                handlePagination();
        });
    }
    
    // Sorting via Shopify (server-side) so it affects the whole collection
    const sortSelect = document.getElementById('sort-select');
    if (sortSelect) {
        // Set initial value based on current URL sort_by
        try {
            const params = new URLSearchParams(window.location.search);
            const current = params.get('sort_by');
            const paramToValue = {
                'created-descending': 'newest',
                'created-ascending': 'oldest',
                'price-ascending': 'price-low',
                'price-descending': 'price-high',
                'title-ascending': 'name-asc',
                'title-descending': 'name-desc',
                'best-selling': 'popular'
            };
            if (current && paramToValue[current]) {
                sortSelect.value = paramToValue[current];
            }
        } catch (e) {}

        sortSelect.addEventListener('change', function() {
            const valueToParam = {
                'newest': 'created-descending',
                'oldest': 'created-ascending',
                'price-low': 'price-ascending',
                'price-high': 'price-descending',
                'name-asc': 'title-ascending',
                'name-desc': 'title-descending',
                'popular': 'best-selling'
            };
            const sortParam = valueToParam[this.value] || 'created-descending';
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', sortParam);

            // Fetch only this section (AJAX) and swap, fallback to full reload
            const sectionEl = document.querySelector('[data-section-id]');
            const sectionId = sectionEl && sectionEl.getAttribute('data-section-id');
            if (!sectionId) { window.location.href = url.toString(); return; }
            const fetchUrl = new URL(url.toString());
            fetchUrl.searchParams.set('section_id', sectionId);
            document.body.classList.add('is-loading');
            fetch(fetchUrl.toString())
              .then(r => r.text())
              .then(html => {
                const tmp = document.createElement('div');
                tmp.innerHTML = html;
                const incoming = tmp.querySelector('#category-items-' + sectionId);
                const current = document.querySelector('#category-items-' + sectionId);
                if (incoming && current) {
                  // Preserve the current items per page selection
                  const currentItemsSelect = current.querySelector('#items-select');
                  const incomingItemsSelect = incoming.querySelector('#items-select');
                  const currentItemsValue = currentItemsSelect ? currentItemsSelect.value : 'all';
                  
                  const incomingGrid = incoming.querySelector('.category-products-grid');
                  const currentGrid = current.querySelector('.category-products-grid');
                  if (incomingGrid && currentGrid) currentGrid.replaceWith(incomingGrid);
                  const incomingPagination = incoming.querySelector('.pagination-container');
                  const currentPagination = current.querySelector('.pagination-container');
                  if (incomingPagination && currentPagination) currentPagination.replaceWith(incomingPagination);
                  const incomingFilters = incoming.querySelector('.filters-sidebar');
                  const currentFilters = current.querySelector('.filters-sidebar');
                  if (incomingFilters && currentFilters) currentFilters.replaceWith(incomingFilters);
                  
                  // Restore the items per page selection
                  const newItemsSelect = current.querySelector('#items-select');
                  if (newItemsSelect && incomingItemsSelect) {
                    newItemsSelect.value = currentItemsValue;
                    // Update the currentItemsPerPage variable
                    if (currentItemsValue === 'all') {
                      currentItemsPerPage = 1000;
                    } else {
                      currentItemsPerPage = parseInt(currentItemsValue);
                    }
                    // Apply pagination after sorting
                    handlePagination();
                  }
                }
                window.history.pushState({}, '', url.toString());
              })
              .catch(() => { window.location.href = url.toString(); })
              .finally(() => { document.body.classList.remove('is-loading'); });
        });
    }
        
        // Set the initial items per page from the dropdown
    const itemsSelect2 = document.getElementById('items-select');
    if (itemsSelect2) {
        const initialValue = itemsSelect2.value;
            if (initialValue === 'all') {
                currentItemsPerPage = 1000;
            } else {
                currentItemsPerPage = parseInt(initialValue) || 24;
            }
        }
        
    // Initialize pagination
        handlePagination();
    
    // Initialize filter functionality
    setupFilterClickHandlers();
});

// Function to update product price
function updateProductPrice(productCard, variantPrice, variantComparePrice) {
    const priceContainer = productCard.querySelector('.product-price');
    if (!priceContainer) return;
    
    // Clear existing price elements
    priceContainer.innerHTML = '';
    
    // Check if variant has a compare at price (sale price)
    if (variantComparePrice && variantComparePrice !== '' && variantComparePrice !== variantPrice) {
        // Product is on sale
        priceContainer.innerHTML = `
            <span class="current-price">${variantPrice}</span>
            <span class="original-price">
                <span class="was-text">WAS</span> 
                <span class="price-text">${variantComparePrice}</span>
            </span>
        `;
    } else {
        // Regular price
        priceContainer.innerHTML = `
            <span class="price-normal">${variantPrice}</span>
        `;
    }
}

// Color swatch and size variant functionality
document.addEventListener('DOMContentLoaded', function() {
    // Handle color swatch clicks
    document.addEventListener('click', function(e) {
        const swatchBtn = e.target.closest('.product-color-swatch-btn');
        if (swatchBtn && !swatchBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();

        const productId = swatchBtn.getAttribute('data-product-id');
            const variantId = swatchBtn.getAttribute('data-variant-id');
            const variantImage = swatchBtn.getAttribute('data-variant-image');
            const colorValue = swatchBtn.getAttribute('data-color-value');
            const variantPrice = swatchBtn.getAttribute('data-variant-price');
            const variantComparePrice = swatchBtn.getAttribute('data-variant-compare-price');

            // Find the product card
        const productCard = swatchBtn.closest('.product-card');
            const productImage = productCard.querySelector('.category-product-image');
            const productLink = productCard.querySelector('.product-link');
            
            // Update the product image
            if (productImage && variantImage) {
                productImage.style.backgroundImage = `url('${variantImage}')`;
                // Mark as variant-updated to prevent lazy loading from overwriting
                productImage.setAttribute('data-variant-updated', 'true');
            }
            
            // Update the product price
            updateProductPrice(productCard, variantPrice, variantComparePrice);
            
            // Update selected swatch state
            const swatchesContainer = swatchBtn.closest('.product-color-swatches');
            const allSwatches = swatchesContainer.querySelectorAll('.product-color-swatch-btn');
            allSwatches.forEach(swatch => {
                swatch.classList.remove('selected');
            });
            swatchBtn.classList.add('selected');
            
            // Update the product link to include variant parameter
            if (productLink && variantId) {
                const currentUrl = new URL(productLink.href);
                currentUrl.searchParams.set('variant', variantId);
                productLink.href = currentUrl.toString();
            }
            
            // Store the selected variant for this product
            if (productId && variantId) {
                localStorage.setItem(`selected_variant_${productId}`, variantId);
                localStorage.setItem(`selected_color_${productId}`, colorValue);
            }
        }
    });

    // Handle size variant clicks
    document.addEventListener('click', function(e) {
        const sizeBtn = e.target.closest('.product-size-btn');
        if (sizeBtn && !sizeBtn.disabled) {
            e.preventDefault();
            e.stopPropagation();
            
            const productId = sizeBtn.getAttribute('data-product-id');
            const variantId = sizeBtn.getAttribute('data-variant-id');
            const variantImage = sizeBtn.getAttribute('data-variant-image');
            const sizeValue = sizeBtn.getAttribute('data-size-value');
            const variantPrice = sizeBtn.getAttribute('data-variant-price');
            const variantComparePrice = sizeBtn.getAttribute('data-variant-compare-price');
            
            // Find the product card
            const productCard = sizeBtn.closest('.product-card');
        const productImage = productCard.querySelector('.category-product-image');
            const productLink = productCard.querySelector('.product-link');
            
            // Update the product image
            if (productImage && variantImage) {
                productImage.style.backgroundImage = `url('${variantImage}')`;
                // Mark as variant-updated to prevent lazy loading from overwriting
                productImage.setAttribute('data-variant-updated', 'true');
            }
            
            // Update the product price
            updateProductPrice(productCard, variantPrice, variantComparePrice);
            
            // Update selected size state
            const sizesContainer = sizeBtn.closest('.product-size-variants');
            const allSizes = sizesContainer.querySelectorAll('.product-size-btn');
            allSizes.forEach(size => {
                size.classList.remove('selected');
            });
            sizeBtn.classList.add('selected');
            
            // Update the product link to include variant parameter
            if (productLink && variantId) {
                const currentUrl = new URL(productLink.href);
                currentUrl.searchParams.set('variant', variantId);
                productLink.href = currentUrl.toString();
            }
            
            // Store the selected variant for this product
            if (productId && variantId) {
                localStorage.setItem(`selected_variant_${productId}`, variantId);
                localStorage.setItem(`selected_size_${productId}`, sizeValue);
            }
        }
    });
    
    // Restore selected variants on page load
    const allProductCards = document.querySelectorAll('.product-card');
    allProductCards.forEach(card => {
        const productLink = card.querySelector('.product-link');
        const swatchesContainer = card.querySelector('.product-color-swatches');
        const sizesContainer = card.querySelector('.product-size-variants');
        
        // Get the actual product ID from either container
        const productId = swatchesContainer?.getAttribute('data-product-id') || sizesContainer?.getAttribute('data-product-id');
        
        if (productLink && productId) {
            // Check if we have a stored variant for this product
            const storedVariantId = localStorage.getItem(`selected_variant_${productId}`);
            const storedColor = localStorage.getItem(`selected_color_${productId}`);
            const storedSize = localStorage.getItem(`selected_size_${productId}`);
            
            // Restore color selection
            if (storedVariantId && storedColor && swatchesContainer) {
                const targetSwatch = swatchesContainer.querySelector(`[data-color-value="${storedColor}"]`);
                if (targetSwatch && !targetSwatch.disabled) {
                    // Set as selected
                    const allSwatches = swatchesContainer.querySelectorAll('.product-color-swatch-btn');
                    allSwatches.forEach(swatch => {
                        swatch.classList.remove('selected');
                    });
                    targetSwatch.classList.add('selected');
                    
                    // Image is already set by immediate initialization script, just ensure the marker is there
                    const productImage = card.querySelector('.category-product-image');
                    if (productImage) {
                        productImage.setAttribute('data-variant-updated', 'true');
                    }
                    
                    // Update price
                    const variantPrice = targetSwatch.getAttribute('data-variant-price');
                    const variantComparePrice = targetSwatch.getAttribute('data-variant-compare-price');
                    updateProductPrice(card, variantPrice, variantComparePrice);
                    
                    // Update link
                    const currentUrl = new URL(productLink.href);
                    currentUrl.searchParams.set('variant', storedVariantId);
                    productLink.href = currentUrl.toString();
                }
            }
            
            // Restore size selection
            if (storedVariantId && storedSize && sizesContainer) {
                const targetSize = sizesContainer.querySelector(`[data-size-value="${storedSize}"]`);
                if (targetSize && !targetSize.disabled) {
                    // Set as selected
                    const allSizes = sizesContainer.querySelectorAll('.product-size-btn');
                    allSizes.forEach(size => {
                        size.classList.remove('selected');
                    });
                    targetSize.classList.add('selected');
                    
                    // Image is already set by immediate initialization script, just ensure the marker is there
                    const productImage = card.querySelector('.category-product-image');
                    if (productImage) {
                        productImage.setAttribute('data-variant-updated', 'true');
                    }
                    
                    // Update price
                    const variantPrice = targetSize.getAttribute('data-variant-price');
                    const variantComparePrice = targetSize.getAttribute('data-variant-compare-price');
                    updateProductPrice(card, variantPrice, variantComparePrice);
                    
                    // Update link
                    const currentUrl = new URL(productLink.href);
                    currentUrl.searchParams.set('variant', storedVariantId);
                    productLink.href = currentUrl.toString();
                }
            }
        }
    });
});
